export interface CandidateSourcingState {
  selectedTab: number;
  indicatorWidth: number;
  selectedEmailForAnalytics: any | null;
}

export const initialCandidateSourcingState: CandidateSourcingState = {
  selectedTab: 0,
  indicatorWidth: 0,
  selectedEmailForAnalytics: null
};

export type CandidateSourcingAction =
  | { type: 'SET_SELECTED_TAB'; payload: number }
  | { type: 'SET_INDICATOR_WIDTH'; payload: number }
  | { type: 'SET_SELECTED_EMAIL_FOR_ANALYTICS'; payload: any | null }
  | { type: 'CLEAR_SELECTED_EMAIL_FOR_ANALYTICS' };

export const candidateSourcingReducer = (
  state: CandidateSourcingState,
  action: CandidateSourcingAction
): CandidateSourcingState => {
  switch (action.type) {
    case 'SET_SELECTED_TAB':
      return {
        ...state,
        selectedTab: action.payload
      };
    case 'SET_INDICATOR_WIDTH':
      return {
        ...state,
        indicatorWidth: action.payload
      };
    case 'SET_SELECTED_EMAIL_FOR_ANALYTICS':
      return {
        ...state,
        selectedEmailForAnalytics: action.payload
      };
    case 'CLEAR_SELECTED_EMAIL_FOR_ANALYTICS':
      return {
        ...state,
        selectedEmailForAnalytics: null
      };
    default:
      return state;
  }
};
